module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/group-layout/group-layout.component.scss
// module id = ./src/app/layouts/group-layout/group-layout.component.scss
// module chunks = main